import { Component, OnInit, Inject } from '@angular/core';
// import { FormGroup } from '@angular/forms/src/model';
// import { FormBuilder } from '@angular/forms/src/form_builder';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentsService } from '../services/documents.service';
import {Validators, FormGroup, FormBuilder} from '@angular/forms';
import {HttpClient,HttpEventType} from '@angular/common/http';
import { LoaderService } from '../services/loader.service';
import { FeedbackService } from '../services/feedback.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  selectedFile : File = null;
  public documentForm:FormGroup;
  public options;
  public selected;
  public progressbarDisplay = 'none';
  public progressbarValue = 0;
  public pro;
  public selectedTitle = "";
  public others = false;
  constructor(private _formBuilder : FormBuilder, 
    private dialogRef: MatDialogRef<DocumentsComponent>,
    private _documentsService: DocumentsService,
    private http : HttpClient,
    private _feedbackService: FeedbackService,
    @Inject(MAT_DIALOG_DATA) public data: any
) { }
  closer():void{
    this.dialogRef.close();
  }
  ngOnInit() {
    this.documentForm = this._formBuilder.group({
      sn:[],
      title:['',[Validators.required]],
      desc:['',[Validators.required]],
      file:['' ,[Validators.required]]
    })
    this.options = this._documentsService.options;
  }

  selectTitle () {
    if (this.selectedTitle == "Others") {
      this.others = true;
    } else if (this.selectedTitle != "Others") {
      this.others = false;
      this.documentForm.get('title').setValue(this.selectedTitle);
    }
  }
  // uploadFile(e){
  //   this._documentsService.uploadFile(e);
  // }


  onFileSelected(event) {
    // this.selectedFile = <File>event.target.files[0];
    this.documentForm.get("file").setValue(<File>event.target.files[0])
  }

  onUpload(){
    const fd = new FormData();
    fd.append('dtitle', this.documentForm.get("title").value);
    fd.append('ddesc', this.documentForm.get("desc").value);
    fd.append('fileToUpload', this.documentForm.get("file").value, this.documentForm.get("file").value.name);
    this.progressbarDisplay = 'block';
    this._documentsService.sendDoc(fd).subscribe((data:any)=>{
      if(data.type === HttpEventType.UploadProgress){
        this.progressbarValue = Math.round(data.loaded/data.total*100);
        this.pro = Math.round(data.loaded/data.total*100)+"%";
      }else if(data.type === HttpEventType.Response){
        // this._feedbackService.emitChange(data.body.message, "primary-color");
      }
      this.dialogRef.close({...data, doc_title: this.documentForm.get("title").value});
    })
    // this.http.post('/api/test.php',fd).subscribe(data => {
    //   console.log(data);
    // })
  }
  // onSubmit(){
  //  // this._documentsService.addDocument(this.documentForm.value);
  //   this.dialogRef.close();
  // }


}

